var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIconsMision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e1441ddd-13cd-4749-9bf0-0e2f0f7076e7",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.56,261.93a11.94,11.94,0,0,0-14.91-3.72l-25.41,12.42s-25.62,46.28-26.77,46.28c-.95,0-39.42,1.85-52.39,2.48a10.51,10.51,0,0,0-7.13,3.26l-21.18,22.18L94.66,346.9a9.05,9.05,0,0,0-7.57,4.77l-7.33,13.76A7.06,7.06,0,0,0,86,375.81H319.15a6,6,0,0,0,6-6V312.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.46,236.21s15.3-25.24,31.62-29.32l-.77,44.62-5.1,35.19-20.14,46.66,32.13-2,15.3-35.95L157.34,263l29.83,12.5-3.31,30.34,29.58-2.29,3.85-32a19.06,19.06,0,0,0-11.83-20l-22.37-9,.77-45.14s21.42-2.7,43-24.56l.54,1.29a7.06,7.06,0,0,0,6.5,4.31,6.94,6.94,0,0,0,2.73-.55,7,7,0,0,0,3.76-9.23l-3.29-7.81c1.48-2,2.94-4.07,4.38-6.28,0,0,5.61-7.91-2.8-15.56-3.82-4.1-8.07-4.17-11.89-2.64L207.71,91.13l46.61-18.56a5.62,5.62,0,0,0,3.13-7.35L241.85,26.8a5.64,5.64,0,0,0-7.41-3.07L187.61,43.41l-2.1-5a7,7,0,1,0-13,5.47l42.89,101.82-.19.24s-17,24.22-40.35,28.66a38,38,0,0,1-8.32.53c-9.9-.33-46.74.15-70.4,23.59L76,224.23s-4.84,11.22,5.61,17.08S99.46,236.21,99.46,236.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.61,168.39a27.29,27.29,0,1,0-27.28-27.29A27.29,27.29,0,0,0,156.61,168.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconsMision);
export default __webpack_public_path__ + "static/media/web-icons_mision.802d417761d93c498fada862e757fc5d.svg";
export { ForwardRef as ReactComponent };